import React from 'react';
import stylesHeader from './Header.module.css';
import ProfiloUtente from "../profiloUtente/ProfiloUtente";
import logoRegioneVeneto from "../../img/logo/logo-regione-veneto--bw.png"
import MediaQueryUtils from "../../utils/MediaQueryUtils";

function Header (props) {
    let isPageWide = MediaQueryUtils('(min-width: 1450px)')
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    return (
            <header className={"row"} style={{backgroundColor: "#333333", height: "80px",margin:"0px",alignItems:"center"}}>
                <div className={"col-3"}>
                    <img style={{marginLeft:"10px"}} alt="Regione Veneto" src={logoRegioneVeneto}/>
                </div>
                {isPageWide? <div className={sessioneUtente && sessioneUtente.tipoUtente !== "03"?"col-6":"col-5"} style={{textAlign: "center"}}>
                    <span className={"noPrint ".concat(stylesHeader.labelNomeApplicazione)}>Registro Assistenti Familiari</span>
                </div>:<div className={"col-3"}/>}
                <div className={isPageWide? sessioneUtente && sessioneUtente.tipoUtente !== "03"?"col-3":"col-4":"col-6"} >
                    {window.location.pathname === "/login"|| window.location.pathname === "/login-callback"?<></>:<ProfiloUtente/>}
                </div>
            </header>
        );
}
export default Header;
